import React, { Suspense } from 'react';

const DelayedPaymentStep =
  React.lazy(() => import(/* webpackChunkName: "payment-step.async" */ './payment-step')
    .then(({ PaymentStepWithI18n }) => ({
      default: PaymentStepWithI18n,
    })));

export const DelayedPaymentStepWithI18n = () => (
  <Suspense fallback={null}>
    <DelayedPaymentStep />
  </Suspense>
);
